import * as React from 'react'
import Button, { ButtonProps } from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { styled } from '@mui/material/styles'

interface Props {
  open: boolean
  onClose: (e: React.MouseEvent) => void
  onSubmit: (e: React.MouseEvent) => void
  titleLabel: string
  subtitleLabel: string
  cancelLabel: string
  submitLabel: string
}
export default function CustomDialog(props: Props) {
  const {
    open,
    onClose,
    onSubmit,
    titleLabel,
    subtitleLabel,
    cancelLabel,
    submitLabel,
  } = props

  const StyledDialogButton = styled(Button)<ButtonProps>(({ theme }) => ({
    width: '148px',
    height: '28px',
    paddingLeft: '8px',
    paddingRight: '8px',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '18.75px',
    textTransform: 'none',
    color: 'black',
    borderRadius: '6px',
  }))

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { pt: '4px', pb: '20px', borderRadius: '20px' },
      }}
    >
      <DialogTitle color="black" sx={{ textAlign: 'center', fontSize: '19px' }}>
        {titleLabel}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          sx={{
            whiteSpace: 'pre-line',
            textAlign: 'center',
            color: 'black',
            fontSize: '16px',
          }}
        >
          {subtitleLabel}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-evenly' }}>
        <StyledDialogButton
          variant="contained"
          onClick={onClose}
          sx={{
            bgcolor: '#D9D9D9',
            '&:hover': {
              bgcolor: '#D9D9D9',
            },
          }}
        >
          {cancelLabel}
        </StyledDialogButton>
        <StyledDialogButton
          variant="contained"
          onClick={onSubmit}
          sx={{ bgcolor: 'primary' }}
        >
          {' '}
          {submitLabel}{' '}
        </StyledDialogButton>
      </DialogActions>
    </Dialog>
  )
}
